/**
 * ajaxRequest status
 * @module
 */

/**
 * @enum {number}
 */
export default {
    /**
     * Status code-Success
     */
    CODE_SUCCESS: 1000,
    /**
     * Status code-Not logged in
     */
    CODE_UNLOGIN: -1001,
    /**
     * Status code-Insufficient permissions
     */
    CODE_PERMISSION_DENIED: -1002,
    /**
     * Loading
     * @type {Symbol}
     */
    LOADING: Symbol('LOADING'),
    /**
     * Load success
     * @type {Symbol}
     */
    SUCCESS: Symbol('SUCCESS'),
    /**
     * Load failed
     * @type {Symbol}
     */
    FAILURE: Symbol('FAILURE'),
};